export default "__VITE_PUBLIC_ASSET__8ee889ca__"